import { motion, useInView, useReducedMotion } from "framer-motion";
import { useRef, type ReactNode } from "react";
import { EASE, viewportOnce } from "@/lib/motion";

/* Masked line reveal — text slides up from behind an overflow mask.
   The wrapper (not the translated inner) is observed, so reveals fire reliably. */
export const Mask = ({
  children,
  delay = 0,
  className = "",
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) => {
  const rm = useReducedMotion();
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, { once: true, amount: 0.2 });
  return (
    <span ref={ref} className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block will-change-transform"
        initial={{ y: "112%" }}
        animate={inView ? { y: "0%" } : { y: "112%" }}
        transition={rm ? { duration: 0 } : { duration: 1, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
};

/* Soft fade-up for paragraphs, images, blocks */
export const Fade = ({
  children,
  delay = 0,
  className = "",
  y = 28,
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
  y?: number;
}) => {
  const rm = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: rm ? 0 : y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={viewportOnce}
      transition={rm ? { duration: 0 } : { duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
};
